<template>
    <pop
        customClass="share-pop"
        popMaskClass="share-pop-mask"
        :allowClose="false"
        ref="pop"
        closeClass="close"
        closeIcon="icon-close"
    >
        <div
            class="share-container"
            :class="theme"
            v-outsidetouchstart="closePop"
        >
            <div class="share-box">
                <a
                    class="item"
                    :href="messageHref"
                    target="_top"
                    rel="noopener noreferrer"
                >
                    <span class="iconfont icon-massage-bubble message"></span>
                    <span>{{ $t('md-detail-info.message') }}</span>
                </a>
                <a
                    class="item"
                    :href="emailHref"
                    target="_top"
                    rel="noopener noreferrer"
                >
                    <span class="iconfont icon-email-small email"></span>
                    <span>{{ $t('md-detail-info.email') }}</span>
                </a>
                <a
                    v-if="shares.facebookHref"
                    class="item"
                    :href="shares.facebookHref"
                    target="_top"
                    rel="noopener noreferrer"
                >
                    <span class="iconfont icon-facebook-sign facebook"></span>
                    <span>{{ $t('md-detail-info.facebook') }}</span>
                </a>
                <a
                    v-if="shares.twitterHref"
                    class="item"
                    :href="shares.twitterHref"
                    target="_top"
                    rel="noopener noreferrer"
                >
                    <span class="iconfont icon-newnewtwitter twitter"></span>
                    <span>{{ $t('md-detail-info.twitter') }}</span>
                </a>
                <a
                    v-if="shares.linkedinHref"
                    class="item"
                    :href="shares.linkedinHref"
                    target="_top"
                    rel="noopener noreferrer"
                >
                    <span class="iconfont icon-linkedin linkedin"></span>
                    <span>{{ $t('md-detail-info.linkedin') }}</span>
                </a>
                <div class="item" @click="copylink">
                    <span class="iconfont icon-Copylink copylink"></span>
                    <span>{{ $t('md-detail-info.copylink') }}</span>
                </div>
            </div>
            <div class="close-box" @click="closePop">
                <span class="iconfont icon-close-light close"></span>
            </div>
        </div>
    </pop>
</template>

<script>
import util from '../../common/util';
export default {
    i18next: {
        ns: 'md-detail-info'
    },
    data: function() {
        return {
            messageHref: '',
            emailHref: ''
        };
    },
    props: {
        shares: {
            required: true,
            type: Object
        },
        theme: {
            type: String,
            default: 'standard'
        }
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            // share current page url
            let link = this.pageLocation.href.replace(/\?.*/, '');
            let text = this.$t('md-detail-info.takeALookAtThisProperty', {
                link,
                interpolation: { escapeValue: false }
            });
            // android and ios
            this.messageHref = `sms:?&body=${encodeURIComponent(text)}`;
            this.emailHref = `mailto:?body=${encodeURIComponent(text)}`;
        },
        copylink() {
            let link = this.pageLocation.href.replace(/\?.*/, '');
            const input = document.createElement('input');
            input.setAttribute('readonly', true);
            input.setAttribute('value', link);
            input.style.cssText = 'position:fixed;left:-99999px;bottom:0;';
            document && document.body.appendChild(input);
            input.select();
            input.setSelectionRange(0, input.value.length);
            let toastMsg = '';
            try {
                let success = document.execCommand('copy');
                toastMsg = success
                    ? this.$t('md-detail-info.copied')
                    : this.$t('md-detail-info.error');
            } catch (e) {
                toastMsg = this.$t('md-detail-info.error');
                console.log('Oops, unable to copy');
            }
            util.toast(toastMsg);
            input.parentElement && input.parentElement.removeChild(input);
            this.closePop();
        },
        closePop() {
            this.$refs.pop.close();
        }
    }
};
</script>
<style lang="scss">
.share-pop-mask {
    z-index: var(--level-subhigh);
}
.share-pop {
    height: 100%;
    z-index: var(--level-subhigh);
    .share-container {
        position: absolute;
        bottom: 0px;
        left: 0px;
        right: 0px;
        background-color: #ffffff;
        .share-box {
            display: flex;
            padding: 20px 0;
            width: 100%;
            flex-wrap: wrap;
            .item {
                width: 25%;
                font-size: 12px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                color: var(--color-theme);
                .iconfont {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    line-height: 40px;
                    text-align: center;
                    font-size: 20px;
                    color: #ffffff;
                    margin-bottom: 8px;
                    &.message {
                        background-color: #00cc60;
                    }
                    &.email {
                        background-color: #ff4641;
                    }
                    &.facebook {
                        background-color: #4063b3;
                    }
                    &.twitter {
                        background-color: #1da1f2;
                    }
                    &.linkedin {
                        background-color: #0a8dcb;
                    }
                    &.copylink {
                        background-color: #f5f6fa;
                        color: #8b93a7;
                    }
                }
                &:nth-child(n + 5) {
                    margin-top: 30px;
                }
            }
        }
        .close-box {
            height: 45px;
            width: 100%;
            line-height: 44px;
            border-top: solid 1px rgba(214, 218, 232, 0.7);
            text-align: center;
            .close {
                color: #4a4a60;
                font-size: 16px;
                font-weight: bolder;
            }
        }
        &.classic {
            .share-box .item {
                color: #202437;
            }
        }
        &.standard {
            .share-box .item {
                color: #515666;
            }
        }
        &.fashion {
            .share-box .item {
                color: #4a4a60;
            }
        }
    }
}
</style>
